import type { BoardPoint } from '@wx-weiqi/contracts';

export const BOARD_VIEW_SIZE = 1_000;
export const BOARD_PADDING = 42;
const STONE_SPACING_RATIO = 2.05;
const STONE_EDGE_CLEARANCE = 10;

export interface BoardViewport {
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
}

export function boardPadding(size: 9 | 13 | 19): number {
  const intervals = size - 1;
  // Leave room for a nearly full-cell stone at the outermost intersections.
  return Math.max(
    BOARD_PADDING,
    (BOARD_VIEW_SIZE + STONE_SPACING_RATIO * intervals * STONE_EDGE_CLEARANCE) /
      (2 + STONE_SPACING_RATIO * intervals),
  );
}

export function boardCoordinate(size: 9 | 13 | 19, index: number): number {
  const padding = boardPadding(size);
  return padding + (index * (BOARD_VIEW_SIZE - padding * 2)) / (size - 1);
}

export function stoneRadius(size: 9 | 13 | 19): number {
  return (boardCoordinate(size, 1) - boardCoordinate(size, 0)) / STONE_SPACING_RATIO;
}

export function starPoints(size: 9 | 13 | 19): readonly BoardPoint[] {
  if (size === 9) return fiveStars(2, 4, 6);
  if (size === 13) return fiveStars(3, 6, 9);
  return [3, 9, 15].flatMap((y) => [3, 9, 15].map((x) => ({ x, y })));
}

function fiveStars(low: number, center: number, high: number): readonly BoardPoint[] {
  return [
    { x: low, y: low },
    { x: high, y: low },
    { x: center, y: center },
    { x: low, y: high },
    { x: high, y: high },
  ];
}

export function pointKey(point: BoardPoint): string {
  return `${point.x}:${point.y}`;
}
